import { ErrorPageResponse } from '@magal/models'
import {
  getErrorPage,
  getSiteConfiguration,
} from '@magal/services/sanity-service'
import { GetStaticProps, NextPage } from 'next'
import { ErrorPage } from '@magal/components'
import { useTranslation } from 'react-i18next'
import { captureException } from '@sentry/nextjs'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

const Custom404: NextPage<ErrorPageResponse> = ({ pageData }) => {
  const { t } = useTranslation('errorPages')

  const router = useRouter()

  useEffect(() => {
    const { asPath, pathname } = router

    const disabledPaths = ['/fr', '/de']
    const isDisabledPath = disabledPaths.some((path) => asPath.startsWith(path))

    if (pathname === '/404' && isDisabledPath) {
      router.push('/')
    }
  }, [router])

  return (
    <ErrorPage
      pageData={pageData}
      initialTitle={'404'}
      initialDescription={t('pageNotFound')}
      initialButtonLabel={t('goBackToShopping')}
    />
  )
}

export const getStaticProps: GetStaticProps<ErrorPageResponse> = async ({
  locale,
  preview = false,
}) => {
  const siteConfigurationRes = await getSiteConfiguration(locale, preview)

  if (siteConfigurationRes.status === 'ERROR') {
    const exception = new Error(
      `[404] Sanity getSiteConfiguration function error ${JSON.stringify(
        siteConfigurationRes.errors,
      )}`,
    )
    captureException(exception)
    throw exception
  }
  const { data: siteConfiguration } = siteConfigurationRes

  const pageData = await getErrorPage(locale, preview, 'notFound')
  return {
    props: {
      siteConfiguration,
      pageData,
      showFooter: true,
    },
    revalidate: 60 * 30,
  }
}

export default Custom404
